import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import React from 'react';
import PropTypes from 'prop-types';

var Slide = function Slide(props) {
  var className = props.className,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var newClassName = 'lfs-slide ';
  newClassName += className || '';
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: newClassName
  }, otherProps), props.children);
};

Slide.propTyes = {
  className: PropTypes.string
};
export default Slide;